//#region src/registry/create-document-name.ts
function createDocumentName(namespace, slug) {
	return `${namespace}/${slug}`;
}
//#endregion
export { createDocumentName };

//# sourceMappingURL=create-document-name.js.map